module.exports = __webpack_public_path__ + "static/media/arrow-left.0326e164.svg";